
const WordNetwork = require('./network')
const description = require('./word_network_description.html')

const NAME = '단어 네트워크'

module.exports = {
    name: NAME,
    add: (analysis) => new WordNetwork(NAME, analysis, {onlyKeywords: false}),
    description: description,
}
